export var isSomeWeekdaySelected = function (weekDaySelected) {
    var result = false;
    for (var key in weekDaySelected) {
        if (weekDaySelected[key]) {
            result = true;
            break;
        }
    }
    return result;
};
export var InvertWeekDays = {
    0: 'sunday',
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday'
};



//////////////////
// WEBPACK FOOTER
// ./src/components/PriceCalendar/Utils.ts
// module id = 594
// module chunks = 0